/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Thiswillmarktheeventascanceledandnotifyattendees9Inputs */

const en_thiswillmarktheeventascanceledandnotifyattendees9 = /** @type {(inputs: Thiswillmarktheeventascanceledandnotifyattendees9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The event will be cancelled. Buyers, people signed up and people interested are told. This cannot be undone.`)
};

const de_thiswillmarktheeventascanceledandnotifyattendees9 = /** @type {(inputs: Thiswillmarktheeventascanceledandnotifyattendees9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Event wird abgesagt. Käufer, Angemeldete und Interessierte bekommen Bescheid. Das lässt sich nicht rückgängig machen.`)
};

/**
* | output |
* | --- |
* | "The event will be cancelled. Buyers, people signed up and people interested are told. This cannot be undone." |
*
* @param {Thiswillmarktheeventascanceledandnotifyattendees9Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const thiswillmarktheeventascanceledandnotifyattendees9 = /** @type {((inputs?: Thiswillmarktheeventascanceledandnotifyattendees9Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Thiswillmarktheeventascanceledandnotifyattendees9Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_thiswillmarktheeventascanceledandnotifyattendees9(inputs)
	return de_thiswillmarktheeventascanceledandnotifyattendees9(inputs)
});
export { thiswillmarktheeventascanceledandnotifyattendees9 as "thisWillMarkTheEventAsCanceledAndNotifyAttendees" }